import Vue from "vue";
import Vuex from "vuex";
//import Axios from "axios";
//import getBaseUrl from "../helpers/getBaseUrl";
// Modules
import dealers from './dealers/_index'
import blog from './blog/_index'
import favorites from './favorites/_index'
import user from './user/_index'
import ad from './ad/_index'

import actions from "./actions";
import state from "./state";
import getters from "@/store/getters";
import mutations from "@/store/mutations";

import moduleOldCars from './old-cars/_index'
import newCars from './new-cars/_index'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        ...state,
        screen: {
            width: null
        }
    },

    mutations,
    actions,
    getters,
    modules: {
        moduleOldCars,
        newCars,
        dealers,
        blog,
        favorites,
        user,
        ad
    }
});

export default store;